import React, { useEffect, useState } from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import { Slide, Grid, TextField, Typography,FormControlLabel, Checkbox, Container} from '@material-ui/core';

import { TimeTable, Schedule, AnsType } from '../utils/constants';



//Redux
import { useDispatch, useSelector } from 'react-redux';
import { addFollowup, addQuestion, getQuestions } from '../redux/actions/admin.actions';
import { AddToQueueTwoTone } from '@material-ui/icons';



const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function AlertDialogSlide({modal, handleModal, vals}) {
  const dispatch = useDispatch();
  const { questions } = useSelector(state => state.data);
  const [open, setOpen] = React.useState(false);
  const [values, setValues] = useState({
    choices: [],
    choiceId: []
  });
  const [question, setQuestion] = useState(null);


  const handleChange = prop => event => {
    setValues({...values, [prop]: event.target.value})
  }

  const handleChangeChoice = (e, ind) => {
    if(e.target){
      console.log(e.target.value)
      console.log(e.target.name)
      console.log(ind)
      let arr = values.choices;
      arr[ind - 1][e.target.name] = e.target.value
      setValues({...values, choices: arr})
    }
 
  }


  const handleClose = () => {
    setOpen(false);
    handleModal(false);
    setValues({choices: [], choiceId: []})
    setQuestion(null)
  };

  const handleAddChoices = () => {
    let arr = values.choices;
      arr.push({
          label: '',
          points: 0,
          index: arr.length + 1
      })
      setValues({ ...values, choices: arr })
  }

  const handleRemChoice = (ind) => {
    let arr = values.choices.filter(a => a.index !== ind);
      setValues({ ...values, choices: arr })
  }

  const handleSubmit = async () => {
    if(values.action === 'aq'){
      dispatch(addQuestion(values))
      .then(rs => {
        console.log(rs)
        dispatch(getQuestions())
        handleClose()
      })
      .catch(err => {
        console.log(err)
      })
    }

    if(values.action === 'addfu' || values.action === 'addCfu'){
      dispatch(addFollowup(values))
      .then(rs => {
        console.log(rs)
        dispatch(getQuestions())
        handleClose()
      })
      .catch(err => {
        console.log(err)
      })
    }
  }

  const handleAnswer = (e) => {
    
    let ind = values.choiceId.find(a => a === e);
    let arr = values.choiceId;
    if(ind !== undefined){
      let indx = arr.findIndex(a => a === e);
     arr.splice(indx, 1);
    } else {
      arr.push(e);
    }
    
    setValues({...values, choiceId: arr});

  }



useEffect(() => {
    setOpen(modal)
}, [modal])


useEffect(() => {
  setValues({...values, ...vals})
}, [vals])

useEffect(() => {
  let qs = questions.find(a => a._id === vals.parentQuestionId);
  if(qs) {
    setQuestion(qs);
    setValues({ ...values, choiceId: vals.choiceId ? vals.choiceId : []})
  }
}, [vals.parentQuestionId, vals.choiceId])

  console.log(values)

  let choices = values.choices.map(a => {

    return (
      <>
      <Grid
      item
      lg={8}
      sm={8}
      xl={8}
      xs={12}
    >
      <TextField
    id="outlined-full-width"
    label="Answer"
    placeholder="Enter Answer"
    helperText={<span className="clickable text-danger" onClick={() => handleRemChoice(a.index)}>Remove Answer</span>}
    fullWidth
    size="small"
    margin="dense"
    InputLabelProps={{
      shrink: true,
    }}
    variant="outlined"
    name="label"
    value={values.choices[a.index - 1].label}
    onChange={(e) => handleChangeChoice(e, a.index)}
  />
  </Grid>
  <Grid
      item
      lg={4}
      sm={4}
      xl={4}
      xs={12}
    >
      <TextField
    id="outlined-full-width"
    label="Points"
    fullWidth
    type="number"
    size="small"
    margin="dense"
    InputLabelProps={{
      shrink: true,
    }}
    variant="outlined"
    name="points"
    value={values.choices[a.index - 1].points}
    onChange={(e) => handleChangeChoice(e, a.index)}
  />
  </Grid>
  </>
    )
  
  })



const answers = question !== null && question.choices.map(a => {
  let chk = values.choiceId.find(ab => ab === a._id);
    console.log(a)
  return(
<FormControlLabel control={
          <Checkbox
            checked={chk ? true : false }
            onClick={() => handleAnswer(a._id)}
            name="label"
            color="primary"
            disabled={a.hasFollowup}
          />
        }
        label={a.label}/>
  )

})















  return (
    <div>
      <Dialog
      fullWidth
      maxWidth="md"
        open={open}
        TransitionComponent={Transition}
        onClose={handleClose}
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle id="alert-dialog-slide-title"><h4>{vals.action === 'addfu' || vals.action === 'addCfu'  ? 'Add Followup Question' : vals.action === 'eq' ? 'Edit Question' : vals.action === 'aq' && 'Add Question' }</h4></DialogTitle>
        <DialogContent>
          <Grid
          container
          spacing={2}
          justify="center"
        >
           <Grid
            item
            lg={12}
           
          >
            {question !== null && <>
           <Typography variant="h4" className="m-1" >Question: <Typography variant="h5" className="d-inline">{question.question}</Typography></Typography>
           <Typography variant="h4" className="m-1" >Answers:</Typography>
            <Container>
              {answers}
              </Container>
      
            </>
            }
            
          </Grid>
          <Grid
            item
            lg={8}
            sm={8}
            xl={8}
            xs={12}
          >
            <TextField
             multiline
             rows={4}
          id="outlined-full-width"
          label="Question"
          placeholder="Enter Question"
          fullWidth
          size="small"
          margin="normal"
          InputLabelProps={{
            shrink: true,
          }}
          variant="outlined"
          name="question"
          value={values.question}
          onChange={handleChange('question')}
        />
             <Grid
          container
          spacing={2}
        >
        <Grid
            item
            lg={8}
            sm={8}
            xl={8}
            xs={12}
          >
            <TextField
          id="outlined-full-width"
          label="Note"
          placeholder="Enter Note"
          fullWidth
          size="small"
          margin="normal"
          InputLabelProps={{
            shrink: true,
          }}
          variant="outlined"
          name="notes"
          value={values.notes}
          onChange={handleChange('notes')}
        />
</Grid>
<Grid
            item
            lg={4}
            sm={4}
            xl={4}
            xs={12}
          >
            <TextField
          id="outlined-full-width"
          label="Time Table"
          placeholder="Placeholder"
          fullWidth
          size="small"
          margin="normal"
          InputLabelProps={{
            shrink: true,
          }}
          select
          SelectProps={{ native: true }}
          variant="outlined"
          name="group"
          value={values.group}
          onChange={handleChange('group')}
        >
                 <option
                    value=""
                  >
                    {''}
                  </option>
                {TimeTable.map((option) => (
                  <option
                    key={option.value}
                    value={option.value}
                  >
                    {option.label}
                  </option>
                ))}

        </TextField>
</Grid>     
</Grid>
</Grid>







<Grid
            item
            lg={4}
            sm={4}
            xl={4}
            xs={12}
          >
           <TextField
          id="outlined-full-width"
          label="Question Points"
          fullWidth
          type="number"
          size="small"
          margin="normal"
          InputLabelProps={{
            shrink: true,
          }}
          variant="outlined"
          name="points"
          value={values.points}
          onChange={handleChange('points')}
        />
  <TextField
          id="outlined-full-width"
          label="Question Type"
          fullWidth
          size="small"
          margin="normal"
          InputLabelProps={{
            shrink: true,
          }}
          variant="outlined"
          name="answer_type"
          value={values.answer_type}
          onChange={handleChange('answer_type')}
          select
          SelectProps={{ native: true }}
        >
                  <option
                    value=""
                  >
                    {''}
                  </option>
                {AnsType.map((option) => (
                  <option
                    key={option.value}
                    value={option.value}
                  >
                    {option.label}
                  </option>
                ))}
          </TextField>
          <TextField
          id="outlined-full-width"
          label="Schedule"
          fullWidth
          size="small"
          margin="normal"
          InputLabelProps={{
            shrink: true,
          }}
          className="pt-1"
          variant="outlined"
          name="interval"
          value={values.interval}
          onChange={handleChange('interval')}
          select
          SelectProps={{ native: true }}
        >
                  <option
                    value=""
                  >
                    {''}
                  </option>
                {Schedule.map((option) => (
                  <option
                    key={option.value}
                    value={option.value}
                  >
                    {option.label}
                  </option>
                ))}
        </TextField>
</Grid>

{values.choices.length === 0 ?
          <Grid 
           lg={12}
           className="center-element p-3"
          >
          <Button variant="outlined" color="primary" onClick={handleAddChoices} >Add Answer</Button>
            </Grid>
          :
          <>
          {choices}
          <Grid 
          lg={12}
          className="center-element"
         >
         <Button variant="outlined" color="primary" onClick={handleAddChoices} >Add Answer</Button>
           </Grid>
          </>
         
}


          </Grid>

        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            Cancel
          </Button>
          <Button onClick={handleSubmit} color="primary">
            Save
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
